import { useState } from "react";
import { PhysShell, Field, ResultCard, Stat, primaryBtn } from "./PhysShell.jsx";
import { collision1D, round } from "./physcore.js";

export default function Momentum() {
  const [m1, setM1] = useState("2");
  const [u1, setU1] = useState("3");
  const [m2, setM2] = useState("1");
  const [u2, setU2] = useState("0");
  const [e, setE] = useState("1");
  const [res, setRes] = useState(null);

  const go = () => {
    const n = (x) => parseFloat(x);
    const eVal = e.trim() === "" ? 1 : parseFloat(e);
    setRes(collision1D(n(m1), n(u1), n(m2), n(u2), eVal));
  };

  return (
    <PhysShell title="Momentum & Collisions">
      <p style={{ fontSize: 13, color: "#5B5E7A", marginTop: 0 }}>
        1D head-on collision. e = restitution: 1 elastic, 0 perfectly inelastic (stick).
      </p>
      <Field label="Mass 1 (m₁)" suffix="kg" value={m1} onChange={(e) => setM1(e.target.value)} />
      <Field label="Velocity 1 (u₁)" suffix="m/s" value={u1} onChange={(e) => setU1(e.target.value)} />
      <Field label="Mass 2 (m₂)" suffix="kg" value={m2} onChange={(e) => setM2(e.target.value)} />
      <Field label="Velocity 2 (u₂)" suffix="m/s" value={u2} onChange={(e) => setU2(e.target.value)} />
      <Field label="Restitution e (blank = 1, elastic)" value={e} onChange={(ev) => setE(ev.target.value)} />
      <button onClick={go} style={primaryBtn}>Solve</button>
      {res && !res.ok && <ResultCard><span style={{ color: "#F8716A" }}>{res.error}</span></ResultCard>}
      {res && res.ok && (
        <ResultCard>
          <Stat label="Final velocity v₁" value={round(res.result.v1, 4)} unit="m/s" />
          <Stat label="Final velocity v₂" value={round(res.result.v2, 4)} unit="m/s" />
          <Stat label="Momentum (before = after)" value={round(res.result.pAfter, 4)} unit="kg·m/s" />
          <Stat label="KE before" value={round(res.result.keBefore, 4)} unit="J" />
          <Stat label="KE after" value={round(res.result.keAfter, 4)} unit="J" />
          <Stat label="KE lost" value={round(res.result.keLoss, 4)} unit="J" />
          {(() => {
            const ev = e === "" ? 1 : Number(e);
            let msg;
            if (ev >= 0.999) msg = "Elastic — kinetic energy is conserved (KE lost ≈ 0).";
            else if (ev <= 0.001) msg = "Perfectly inelastic — the objects stick (v₁ = v₂); the maximum possible KE is lost.";
            else {
              const pct = round((res.result.keLoss / res.result.keBefore) * 100, 1);
              msg = `Partially inelastic — ${pct}% of the kinetic energy is lost; momentum is still conserved.`;
            }
            return (
              <div style={{ marginTop: 14, paddingTop: 12, borderTop: "1px solid #1C1E2E" }}>
                <div style={{ fontSize: 13, color: "#C8CADF", lineHeight: 1.55 }}>{msg}</div>
                <div style={{ fontSize: 12.5, color: "#9A9DBE", marginTop: 8, fontFamily: "ui-monospace, monospace" }}>
                  p<sub>before</sub> = m₁u₁ + m₂u₂ = {round(res.result.pBefore, 4)} kg·m/s = p<sub>after</sub> = m₁v₁ + m₂v₂ = {round(res.result.pAfter, 4)} kg·m/s
                </div>
              </div>
            );
          })()}
        </ResultCard>
      )}
    </PhysShell>
  );
}
